import React, { useRef, useState } from 'react';
import { FormattedMessage } from '@kyruus/intl';

import { ButtonWithIcon } from '@kyruus/button';
import ArrowLeft2 from '@kyruus/react-ikons/ArrowLeft2';

import { messages } from '../lib/messages';
import { BackToMapViewBtnWrapper } from '../styles';

export default function useStreetViewClose() {
  // track whether or not Google Maps Street View is open
  // (we use this to render our own custom close button)
  const [isStreetViewOpen, setIsStreetViewOpen] = useState(false);

  // store a ref in order to programmatically control the Google Map
  // (so we can manually close the street view)
  const mapInstanceRef = useRef();

  // event handlers to register with the @kyruus/gmap component
  // in order to track Street View open/close state
  const mapEvents = {
    streetview_entered: (mapRef) => {
      mapInstanceRef.current = mapRef.current;
      setIsStreetViewOpen(true);
    },
    streetview_exited: () => {
      setIsStreetViewOpen(false);
    }
  };

  // close button markup
  const closeButton = isStreetViewOpen ? (
    <BackToMapViewBtnWrapper>
      <ButtonWithIcon
        active={true}
        mode="contrast"
        icon={<ArrowLeft2 size="11px" />}
        iconAlign="left"
        data-testid="BackToMapView"
        onClick={() => {
          if (mapInstanceRef.current) {
            mapInstanceRef.current.getStreetView().setVisible(false);
          }
        }}
      >
        <FormattedMessage {...messages.backToMapView} />
      </ButtonWithIcon>
    </BackToMapViewBtnWrapper>
  ) : null;

  return {
    mapEvents,
    closeButton,
    isStreetViewOpen
  };
}
